import { Container } from '@mui/material';
import { createBrowserRouter, isRouteErrorResponse, useRouteError } from 'react-router';
import { ApiError } from './api/errors';
import { ErrorAlert } from './components/ErrorAlert';
import { PublicLayout } from './layouts/PublicLayout';
import { adminRoutes } from './admin/routes';
import { publicRoutes } from './public/routes';

function RouteErrorBoundary() {
  const error = useRouteError();
  const shown =
    isRouteErrorResponse(error) && error.status === 404
      ? new ApiError({ code: 'NOT_FOUND', status: 404, requestId: null })
      : error;
  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <ErrorAlert error={shown} />
    </Container>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicLayout />,
    errorElement: <RouteErrorBoundary />,
    children: publicRoutes,
  },
  {
    path: '/admin',
    errorElement: <RouteErrorBoundary />,
    // WS6: load admin pages per route via `lazy: () => import(...)` so the public bundle stays small.
    children: adminRoutes,
  },
]);
